import { render, staticRenderFns } from "./ViewSupplierInvoiceListPopup.vue?vue&type=template&id=3956ed23&scoped=true&"
import script from "./ViewSupplierInvoiceListPopup.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierInvoiceListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956ed23",
  null
  
)

export default component.exports